var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.03516,
    y: 4.66797,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEF0C7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2312_35768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.034 24.6679V28.6679M28.034 32.6679H28.044M26.324 19.5279L17.854 33.6679C17.6793 33.9704 17.5869 34.3132 17.5859 34.6624C17.585 35.0117 17.6754 35.3551 17.8484 35.6585C18.0213 35.9619 18.2707 36.2147 18.5717 36.3918C18.8726 36.5689 19.2148 36.6641 19.564 36.6679H36.504C36.8532 36.6641 37.1953 36.5689 37.4962 36.3918C37.7972 36.2147 38.0466 35.9619 38.2195 35.6585C38.3925 35.3551 38.4829 35.0117 38.482 34.6624C38.481 34.3132 38.3886 33.9704 38.214 33.6679L29.744 19.5279C29.5657 19.234 29.3147 18.991 29.0152 18.8224C28.7156 18.6538 28.3777 18.5652 28.034 18.5652C27.6902 18.5652 27.3523 18.6538 27.0528 18.8224C26.7532 18.991 26.5022 19.234 26.324 19.5279Z",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.03516,
    y: 4.66797,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FFFAEB",
    strokeWidth: 8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2312_35768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16.0352 16.668)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderWarning);
export default __webpack_public_path__ + "static/media/header-warning.8fe9932ef045167acdd35209f1975f8f.svg";
export { ForwardRef as ReactComponent };